import { reduceAndSubmitClaim } from '../../claim/actions/reduce-and-submit-claim';
import { ReduxThunkAction } from '../../redux/redux-actions';
import { KeyTaxDirective } from '../reducer';
import { addKeyTaxDirectiveActionCreator } from './add-directive-record';
import { updateKeyTaxDirectiveActionCreator } from './update-key-tax-directive-record';

type SubmitReturn = Promise<any>;

export type AddAndSubmitKeyTaxDirective = (directive: KeyTaxDirective) => SubmitReturn;

type AddAndSubmitKeyTaxDirectiveThunk = (
    keyTaxDirective: KeyTaxDirective
) => ReduxThunkAction<SubmitReturn>;

export const addAndSubmitKeyTaxDirectiveThunk: AddAndSubmitKeyTaxDirectiveThunk = (
    directive: KeyTaxDirective
) => (dispatch, getState) =>
    reduceAndSubmitClaim(dispatch, getState, addKeyTaxDirectiveActionCreator(directive));

export type UpdateAndSubmitKeyTaxDirective = (
    informationRecordIndex: number,
    informationRecord: KeyTaxDirective
) => SubmitReturn;
type UpdateAndSubmitKeyTaxDirectiveThunk = (
    informationRecordIndex: number,
    keyTaxDirective: KeyTaxDirective
) => ReduxThunkAction<SubmitReturn>;

export const updateAndSubmitKeyTaxDirectiveThunk: UpdateAndSubmitKeyTaxDirectiveThunk = (
    keyTaxDirectiveIndex: number,
    keyTaxDirective: KeyTaxDirective
) => (dispatch, getState) =>
    reduceAndSubmitClaim(
        dispatch,
        getState,
        updateKeyTaxDirectiveActionCreator(keyTaxDirectiveIndex, keyTaxDirective)
    );
